module.exports = __webpack_public_path__ + "assets/img/8_1411_big.d64f236d.jpg";